import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardResolver } from './dashboard.resolver';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';
import { ModalNewsletterComponent } from './modal-newsletter/modal-newsletter.component';

@NgModule({
  imports: [
    NgbModule,
    DataTableModule,
    SharedModule
  ],
  declarations: [DashboardComponent, ModalNewsletterComponent],
  exports: [DashboardComponent],
  providers: [DashboardResolver],
  entryComponents: [ModalNewsletterComponent]
})
export class DashboardModule { }
